"use strict";
var GenerateObservable_1 = require('./GenerateObservable');
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/generate.js
// module id = ../../../../rxjs/observable/generate.js
// module chunks = 4